import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from './layout/layout.component';
import {FormSelectorComponent} from './pages/form-selector/form-selector.component';
import {PublicNotificationsComponent} from './pages/public-notifications/public-notifications.component';
import {CompanyFormComponent} from './pages/company-form/company-form.component';
import {NormalFormComponent} from './pages/normal-form/normal-form.component';
import {ControlComponent} from './pages/control/control.component';
import {ReceivedComponent} from './pages/received/received.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: FormSelectorComponent,
        data: {
          title: 'Milieu Klachten Applicatie Meldformulier',
        },
      },
      {
        path: 'klacht-overlast',
        component: NormalFormComponent,
        data: {
          title: 'Klacht overlast melden - Milieu Klachten Centrale',
        },
      },
      {
        path: 'bedrijfsmelding',
        component: CompanyFormComponent,
        data: {
          title: 'Bedrijfsmelding - Milieu Klachten Centrale',
        }
      },
      {
        path: 'controle',
        component: ControlComponent,
        data: {
          title: 'Milieu Klachten Centrale | Klacht overlast',
        }
      },
      {
        path: 'vastgelegd/:unique_number',
        component: ReceivedComponent,
        data: {
          title: 'Milieu Klachten Centrale | Vastgelegd',
        }
      },
      {
        path: 'publieke-notificatie/:url',
        component: PublicNotificationsComponent,
        data: {
          title: 'Milieu Klachten Centrale | Publieke notificatie',
        }
      },
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledNonBlocking',
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
